var map = {
	"./computer1.jpg": "+Zpw",
	"./computer2.jpg": "XD5W",
	"./computer3.jpg": "4Jwv",
	"./computer4.jpg": "1XMC",
	"./computer5.jpg": "lzD9",
	"./model1.png": "MW7B",
	"./model2.png": "MhJv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aC0X";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images ^\.\/.*$
// module id = aC0X
// module chunks = 0